<template>
  <div class="flex h-full">
    <el-card :class="isOpen ? 'w-600px' : 'hidden'">
      <div class="flex relative items-center justify-between">
        <div class="text-20px">绘制建筑</div>
        <div class="absolute -left-20px -right-20px h-2px top-56px bg-gray-200"></div>
        <el-select
          v-model="currentSelectScene"
          value-key="id"
          :disabled="!loadedScene"
          @change="changeScene"
          placeholder="场景选择"
          size="small"
        >
          <el-option
            v-for="item in modelOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div
        class="mt-20px"
        :class="showBuildInformation ? 'h-[calc(50%-28px)]' : 'h-[calc(100%-56px)]'"
      >
        <div class="h-full">
          <div class="flex items-center justify-between py-20px">
            <div class="flex text-18px flex items-center">
              <div class="border-l-3 border-color-primary flex-1 pl-10px text-[#303133] text-18px">
                建筑列表
              </div>
            </div>
            <div class="flex">
              <el-input
                size="small"
                v-model="filter"
                clearable
                placeholder="请输入建筑名称"
              ></el-input>
              <el-button
                :disabled="!loadedScene"
                size="small"
                class="ml-10px"
                @click="searchData"
                type="primary"
                >搜索</el-button
              >
              <el-button
                type="primary"
                :disabled="!loadedScene || isRead"
                @click="addNewBuild"
                size="small"
                >新增</el-button
              >
            </div>
          </div>
          <div class="h-[calc(100%-125px)]">
            <el-table
              ref="multipleTable"
              height="100%"
              class="w-full"
              @row-click="rowTbaleClick"
              :data="tableData"
              row-key="id"
              :current-row-key="currentRowKey"
              border
              highlight-current-row
              v-loading="buildListLoading"
            >
              <el-table-column
                align="center"
                prop="name"
                label="建筑名称"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                align="center"
                prop="code"
                label="建筑编码"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
          </div>
          <div class="mt-20px flex justify-end">
            <el-pagination
              small
              background
              :pager-count="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="mt-20px h-[calc(50%-28px)]" v-loading="detailLoading" v-if="showBuildInformation">
        <div class="flex text-18px flex items-center pb-10px border-b-gray-200 border-b-2px">
          <div class="border-l-3 border-color-primary flex-1 pl-10px text-[#303133] text-18px">
            {{ editTitle }}
          </div>
        </div>
        <div class="mt-20px h-[calc(100%-52px)] overflow-auto">
          <el-form
            v-loading="isFirstPaint"
            ref="buildForm"
            label-width="160px"
            size="small"
            class="pr-10px"
            :model="buildForm"
            :rules="buildRules"
            :disabled="isRead"
          >
            <el-form-item label="建筑名称" prop="name" class="pr-55px">
              <el-input
                placeholder="请输入"
                v-model="buildForm.name"
                clearable
                @blur="handleNameBlur"
              ></el-input>
            </el-form-item>
            <el-form-item label="建筑编码" prop="code" class="pr-55px">
              <el-input placeholder="请输入" v-model="buildForm.code" clearable></el-input>
            </el-form-item>
            <el-form-item label="位置标绘" prop="drawBuild">
              <el-button
                type="primary"
                :disabled="!loadedScene || isRead"
                size="small"
                @click="activateTool"
                >{{ `${isActivePaint ? '结束' : '开始'}标绘` }}</el-button
              >
            </el-form-item>
            <el-form-item label="视角设置" prop="angleJson">
              <el-button
                :disabled="!loadedScene || isRead"
                type="primary"
                size="small"
                @click="saveAngle"
                >保存视角</el-button
              >
            </el-form-item>
            <el-form-item label="位置坐标" prop="points">
              <el-row
                :gutter="5"
                type="flex"
                align="middle"
                v-for="(item, index) in buildForm.points"
                :key="index + 's'"
              >
                <el-col :span="6">
                  <el-input
                    clearable
                    v-model="item.x"
                    oninput="value = value.replace(/[^\d.]/g,'')"
                    placeholder
                    @input="changePillarPosition"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <el-input
                    clearable
                    v-model="item.y"
                    oninput="value = value.replace(/[^\d.]/g,'')"
                    placeholder
                    @input="changePillarPosition"
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <el-input
                    clearable
                    v-model="item.z"
                    oninput="value = value.replace(/[^\d.]/g,'')"
                    placeholder
                    @input="changePillarPosition"
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="关联组态" prop="configurationId" class="pr-55px">
              <el-select
                ref="classfiySelectTree"
                class="w-full"
                popper-class="paint--modeltree__select"
                value-key="id"
                clearable
                filterable
                @clear="resetDeviesInfo"
                v-model="buildForm.configurationId"
                placeholder="分类"
              >
                <el-tree
                  :props="{
                    label: 'name',
                    children: 'children',
                  }"
                  class="text-white"
                  node-key="id"
                  highlight-current
                  :data="treeData"
                  @node-click="classfiyNodeClick"
                  :expand-on-click-node="false"
                ></el-tree>
                <el-option
                  v-for="item in flatTreeData"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                  class="hidden"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="text-center mb-20px">
            <el-button
              :disabled="!loadedScene || isRead"
              :loading="saveLoading"
              type="primary"
              @click="submitBuild"
              size="small"
              >保存</el-button
            >
            <el-button
              :disabled="!loadedScene"
              size="small"
              @click="$router.push(`${basePath}/position-backend-management/build-floor/build-management`)"
              >返回</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
    <div class="w-10px relative z-99999" :class="isOpen ? 'left-10px' : 'left-0'">
      <i
        class="absolute w-26px h-26px bg-color-primary text-white top-40px -left-10px flex items-center justify-center cursor-pointer rounded-4px"
        :class="isOpen ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"
        @click="isOpen = !isOpen"
      ></i>
    </div>
    <el-card class="flex-1" :class="isOpen ? '' : '-ml-10px'">
      <model-view
        v-if="sceneDataLoad"
        :sceneOptions="sceneOptions"
        @sendPlayer="sendPlayer"
        @loadSceneEnd="loadSceneEnd"
      ></model-view>
    </el-card>
  </div>
</template>
<script>
import {
  every,
  isEmpty,
  isNil,
  cloneDeep,
  map,
  find,
  omit,
  assign,
  get,
  values,
  pick,
  head,
  eq,
  isArray,
  forEach,
  flattenDeep,
} from 'lodash'
import { ModelSceneApi, CompositeStateApi } from '@wiz-api/scene-management'
import { BuildingApi } from '@wiz-api/personnel-position'
import cloudRender from '../../js/index'

const compositeStateApi = new CompositeStateApi()
const modelSceneApi = new ModelSceneApi()
const buildingApi = new BuildingApi()

const ModelView = () => {
  return import('../../components/model/ModelView')
}
export default {
  name: 'drawBuild',
  components: {
    ModelView,
  },
  data() {
    const checkNumber = (rule, value, calback) => {
      const numberReg = /^(-)?(\d+)(\.\d+)?$/
      const checkValue = every(value, (item) => {
        return numberReg.test(item.x) && numberReg.test(item.y) && numberReg.test(item.z)
      })
      if (!checkValue) {
        calback(new Error('请输入正确的位置坐标'))
        return
      }
      if (this.buildForm?.points?.length < 1) {
        calback(new Error('位置坐标至少1个'))
        return
      }
      calback()
    }
    return {
      currentSelectScene: '', // 当前场景
      buildListLoading: false, // 表格加载状态
      detailLoading: false, // 表单加载状态
      loadedScene: false, // 场景是否加载完成
      isOpen: true, // 是否显示左边内容
      player: null, // 三维实例
      modelOptions: [], // 场景数据
      tableData: [], // 表格数据
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      }, // 建筑列表分页
      buildRules: {
        name: { required: true, message: '请输入建筑名称', trigger: 'blur' },
        code: { required: true, message: '请输入建筑编码', trigger: 'change' },
        points: { required: true, validator: checkNumber, trigger: 'blur' },
      }, // 建筑表单校验
      buildForm: {
        sceneId: '',
        code: '',
        name: '',
        angleJson: '{}',
        coordinate: '',
        points: [
          {
            seqNo: 0,
            x: '',
            y: '',
            z: '',
          },
        ],
        configurationId: '',
        relativeGroup: '',
      }, // 建筑表单
      labelTypeList: [
        {
          id: true,
          name: '是',
        },
        {
          id: false,
          name: '否',
        },
      ], // 显示名称列表
      filter: '',
      timerOut: null,
      clickTableTimerOut: null,
      editTitle: '新增建筑',
      showBuildInformation: false, // 是否展示编辑框
      treeData: [], // 关联组态下拉数据
      sceneOptions: {
        isEnableGis: false,
        latitude: 0,
        longitude: 0,
        name: '',
        id: '',
        configurationId: '',
        jsonData: '',
      }, // 场景加载配置项
      isActivePaint: false, // 是否绘制
      markPaintId: '', // 已绘制标签信息
      saveLoading: false, // 保存状态
      currentRowKey: '', // 当前高亮行
      isFirstPaint: true, // 当前是否为首次根据路由渲染
      isBindClick: false, // 是否绑定锚点点击事件
      // 标签定位位置类型
      markPosType: {
        leftTop: 0,
        midTop: 1,
        rightTop: 2,
        leftBottom: 3,
        midBottom: 4,
        rightBottom: 5,
      },
      sceneDataLoad: false, // 场景是否加载完成
      flatTreeData: [], // 组态树数据
    }
  },
  computed: {
    // 是否为选中状态
    isRead() {
      return this.routeInfo.operateType === 'read'
    },
    // 当前路由信息
    routeInfo() {
      return this.$route.query
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return get(Wiz, 'globalSettings.globalConfig.routerBase') ? `/${Wiz.globalSettings.globalConfig.routerBase}` : ''
    }
  },
  async created() {
    // 获取场景列表
    await this.getSceneList()
    this.showBuildInformation = true
    // 获取组态列表
    this.getGroupData()
    if (isEmpty(this.currentSelectScene)) {
      this.$message.warning({
        showClose: true,
        message: '建筑绑定的场景不存在',
      })
      await this.getBuildList(this.$route.query.sceneId)
      await this.getBuildDetail(this.$route.query.id)
      this.loadedScene = true
    } else {
      await this.changeScene(this.currentSelectScene)
    }
    this.sceneDataLoad = true
  },
  deactivated() {
    this.sceneDataLoad = false
  },
  beforeDestroy() {
    // 清空标签
    this.paintMark({})
  },
  methods: {
    // 初始化title
    initFormTitle() {
      if (!this.routeInfo.id || !this.isFirstPaint) {
        return
      }
      this.editTitle = eq(this.routeInfo.operateType, 'update') ? '编辑建筑' : '查看建筑'
    },
    // 扁平化模型树
    transformList(data, resultList = []) {
      if (!isArray(data)) {
        return []
      }
      forEach(data, (node) => {
        resultList.push(pick(node, ['id', 'name']))
        this.transformList(node.children, resultList)
      })
      return resultList
    },
    // 组态树点击事件
    classfiyNodeClick(node) {
      this.buildForm.configurationId = node.id
      this.buildForm.relativeGroup = node.name
      this.$refs.classfiySelectTree.blur()
      this.hidModelNode(true)
    },
    // 隐藏对应节点
    async hidModelNode(isPreview) {
      if (!this.player) {
        return
      }
      const rootNode = await this.player.Native.NodeProxy.rootNode()
      // 取消按钮
      await this.player.Native.NodeProxy.setNodeVisible(rootNode, true)
      if (!isPreview || !this.buildForm.configurationId) {
        return
      }
      // 预览按钮
      const [err, hiddenObj] = await compositeStateApi.getNeedHiddenDetails(
        this.buildForm.configurationId
      )
      const arr = await Promise.all(
        map(hiddenObj, async (item) => {
          const info = await this.player.Native.NodeProxy.findNodeByName(rootNode, item.modelName)
          return info
        })
      )
      const nodePtr = flattenDeep(arr)
      for (let i = 0; i < nodePtr.length; i += 1) {
        this.player.Native.NodeProxy.setNodeVisible(nodePtr[i], false)
      }
    },
    // 清空筛选
    resetDeviesInfo() {
      this.buildForm.configurationId = ''
      this.buildForm.relativeGroup = ''
      this.paintMark({})
    },
    // 获取场景列表
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && !isNil(res)) {
        this.modelOptions = res.items
        this.currentSelectScene =
          get(find(this.modelOptions, ['id', this.routeInfo.sceneId]), 'id') ||
          head(this.modelOptions)?.id
      }
    },
    // 获取场景详情
    async getSceneDetail(id) {
      const [err, res] = await modelSceneApi.get(id)
      let options = null
      if (!err && !isNil(res)) {
        options = pick(res, [
          'isEnableGis',
          'latitude',
          'longitude',
          'name',
          'id',
          'configurationId',
        ])
      }
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id })
      if (!jsonErr) {
        options.jsonData = jsonRes
      }
      if (isEmpty(jsonRes)) {
        this.$message({
          showClose: true,
          message: '当前场景没有模型，不可绘制建筑',
          type: 'warning',
        })
        this.loadedScene = true
        if (this.isFirstPaint && this.$route.query.id) {
          await this.getBuildDetail(this.$route.query.id)
          this.isFirstPaint = false
        }
      }
      this.sceneOptions = cloneDeep(options)
    },
    // 保存当前相机视角
    async saveAngle() {
      const cameraInfo = await cloudRender.Camera.getCurrentCamera(this.player)
      if (cameraInfo) {
        this.buildForm.angleJson = JSON.stringify(cameraInfo.data)
        this.$message({
          showClose: true,
          message: '保存视角成功',
          type: 'success',
        })
      }
    },
    // 绘制标签
    async paintMark(args, isActive) {
      if (!this.player) {
        return
      }
      if (isEmpty(args)) {
        if (!isEmpty(this.markPaintId)) {
          // 如果参数是空，则是卸载
          await cloudRender.Marker.destroyMarker(this.player, this.markPaintId)
          this.markPaintId = ''
        }
        return
      }
      if (!this.buildForm.name) {
        return
      }
      const singleOption = {
        id: Math.random()
          .toString(36)
          .slice(2),
        pos: args.pos,
        background: 'buildFloor',
        visible: true,
        nodeOffset: [0, 0],
        text: this.buildForm.name,
        textColor: '#ffff00ff',
        hasTriangle: true,
        markPosType: 4,
      }
      // 存在已绘制标签则更新
      if (!isEmpty(this.markPaintId)) {
        const updateRes = await cloudRender.Marker.updateBySingleLine(this.player, {
          id: this.markPaintId,
          pos: args.pos,
          text: this.buildForm.name,
          markPosType: 4,
        })
        if (updateRes.status && !eq(isActive, true)) {
          this.buildForm.points = [
            {
              seqNo: 0,
              x: args.pos[0],
              y: args.pos[1],
              z: args.pos[2],
            },
          ]
          this.$refs.buildForm.validateField(['points'])
        }
        return
      }
      // 根据锚点位置绘制标签
      const paintRes = await cloudRender.Marker.createBySingleLine(this.player, singleOption)
      if (get(paintRes.data, 'length')) {
        if (!eq(isActive, true)) {
          this.buildForm.points = [
            {
              seqNo: 0,
              x: args.pos[0],
              y: args.pos[1],
              z: args.pos[2],
            },
          ]
          this.$refs.buildForm && this.$refs.buildForm.validateField(['points'])
        }
        this.markPaintId = paintRes.data[0]
      }
    },
    // 监听场景加载完成
    async loadSceneEnd() {
      this.loadedScene = true
      if (
        this.routeInfo.operateType &&
        this.routeInfo.id &&
        this.routeInfo.sceneId === this.currentSelectScene &&
        this.isFirstPaint
      ) {
        this.editTitle = this.routeInfo.operateType === 'update' ? '编辑建筑' : '查看建筑'
        await this.getBuildDetail(this.routeInfo.id)
        await this.moveToBuild(this.buildForm)
        return
      }
      this.isFirstPaint = false
    },
    // 搜索
    resetSearchData() {
      this.filter = this.$options.data().filter
      this.searchData()
    },
    // 搜索
    searchData() {
      this.page.pageNo = 1
      this.getBuildList()
    },
    // 获取组态树
    async getGroupData() {
      this.treeLoading = true
      const [err, res] = await compositeStateApi.menuPageQueryList({
        isQueryAsTree: true,
        sceneId: this.currentSelectScene,
      })
      if (!err && !isNil(res)) {
        this.treeData = res.items
        this.flatTreeData = this.transformList(res.items)
      }
      this.treeLoading = false
    },
    // 新增建筑
    async addNewBuild() {
      this.showBuildInformation = true
      this.editTitle = '新增建筑'
      // 初始化title
      this.initFormTitle()
      this.buildForm.type = []
      this.$nextTick(() => {
        this.$refs.buildForm && this.$refs.buildForm.resetFields()
      })
      this.activateTool(false)
      this.hidModelNode(false)
      this.paintMark({})
      this.buildForm = this.$options.data().buildForm
    },
    // 切换场景
    async changeScene(id) {
      this.loadedScene = false
      // 清空已绘制标签
      this.paintMark({})
      // 关闭绘制功能
      this.activateTool(false)
      if (this.isRead && !this.isFirstPaint) {
        this.showBuildInformation = false
      } else {
        // 打开新增弹框
        this.addNewBuild()
      }
      // 获取绘制当前选择场景信息
      await this.getSceneDetail(id)
      // 重置当前场景建筑列表
      this.resetSearchData()
      // 获取当前场景组态
      this.getGroupData()
    },
    // 表格row点击事件
    async rowTbaleClick(val) {
      if (!this.loadedScene) {
        this.$message.warning('请等场景加载完成后操作')
      }
      this.editTitle = eq(this.routeInfo.operateType, 'update') ? '编辑建筑' : '查看建筑'
      this.showBuildInformation = true
      this.currentRowKey = val.id
      this.buildForm = {
        ...val,
        points: JSON.parse(val.coordinate || '[]'),
      }
      this.$refs.buildForm && this.$refs.buildForm.clearValidate()
      this.activateTool(false)
      this.hidModelNode(true)
      this.moveToBuild(val)
      if (this.loadedScene) {
        this.paintMark({ pos: values(pick(head(this.buildForm.points), ['x', 'y', 'z'])) }, true)
      }
    },
    // 点击定位到建筑位置
    async moveToBuild(row) {
      if (this.clickTableTimerOut) clearTimeout(this.clickTableTimerOut)
      this.clickTableTimerOut = setTimeout(async () => {
        if (row && row.angleJson) {
          cloudRender.Camera.moveCamera(this.player, 'CameraParam', row.angleJson)
        }
      }, 500)
    },
    // 存储实例化完成的player
    async sendPlayer(player) {
      this.player = player
    },
    // 提交表单
    submitBuild() {
      this.$refs.buildForm.validate(async (value) => {
        if (value) {
          this.saveLoading = true
          const params = assign(
            omit(this.buildForm, [
              'points',
              !this.buildForm.configurationId ? 'configurationId' : '',
            ]),
            {
              sceneId: this.currentSelectScene,
              coordinate: JSON.stringify(this.buildForm.points || []),
            }
          )
          params.isDisplay = true
          // 存在id为编辑
          if (!params.id) {
            const [err, res] = await buildingApi.create({
              body: params,
            })
            this.saveLoading = false
            if (err) {
              return
            }
            this.buildForm = this.$options.data().buildForm
            this.$refs.buildForm.resetFields()
            this.paintMark({})
          } else {
            const [err, res] = await buildingApi.update(params.id, {
              body: params,
            })
            this.saveLoading = false
            if (err) {
              return
            }
          }
          await this.getBuildList()
          this.$message({
            showClose: true,
            message: `${params.id ? '修改' : '新增'}成功`,
            type: 'success',
          })
        }
      })
    },
    // 激活工具
    async activateTool(actionType = true) {
      if (!this.player) {
        return
      }
      if (!this.buildForm.name && actionType) {
        this.$message.warning('请先输入建筑名称和编码')
        return
      }
      // false表示只执行关闭逻辑
      this.isActivePaint = eq(actionType, false) ? false : !this.isActivePaint
      if (!this.isActivePaint) {
        if (this.isBindClick) {
          this.player.Native.ModelTree.EventBrowseLClick.disconnect(this.paintMark)
          this.isBindClick = false
        }
        return
      }
      this.player.Native.ModelTree.EventBrowseLClick.connect(this.paintMark)
      this.isBindClick = true
    },
    // 建筑名称修改的处理
    async handleNameBlur() {
      if (!isEmpty(this.markPaintId)) {
        this.paintMark({ pos: values(pick(head(this.buildForm.points), ['x', 'y', 'z'])) }, true)
      }
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.getBuildList()
    },
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getBuildList()
    },
    // 修改建筑坐标
    async changePillarPosition() {
      if (this.timerOut) clearTimeout(this.timerOut)
      this.timerOut = setTimeout(async () => {
        this.paintMark({ pos: values(pick(head(this.buildForm.points), ['x', 'y', 'z'])) }, true)
      }, 500)
    },
    // 获取建筑列表
    async getBuildList(sceneId) {
      this.buildListLoading = true
      const params = {
        sceneId: sceneId || this.currentSelectScene,
        filter: this.filter,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      }
      // 获取分页列表
      const [err, res] = await buildingApi.getList(params)
      if (!err && res) {
        this.tableData = res.items
        this.page.total = res.totalCount
        this.$nextTick(() => {
          this.$refs.buildForm && this.$refs.multipleTable.doLayout()
        })
      }
      this.buildListLoading = false
    },
    // 获取建筑详情
    async getBuildDetail(id) {
      this.detailLoading = true
      const [err, res] = await buildingApi.get(id)
      this.isFirstPaint = false
      this.detailLoading = false
      if (!err && res) {
        this.buildForm = assign(res, {
          points: JSON.parse(res.coordinate),
        })
        // 初始化表格高亮
        if (!this.currentRowKey) {
          this.currentRowKey = this.buildForm.id
        }
        this.paintMark({ pos: values(pick(head(this.buildForm.points), ['x', 'y', 'z'])) }, true)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-card__body {
    height: 100%;
  }
}
</style>

<style lang="scss">
.paint--modeltree__select {
  min-height: 150px;
  max-height: 300px;
  .el-select-dropdown__empty {
    transform: translateY(100%);
  }
}
</style>
